export * from './getCreditCardIcon';
